<template>
  <div class="batchStop">
    <el-dialog
      title="批量停诊排班"
      :visible.sync="visible"
      width="450px"
      top="30vh"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
      :before-close="close">
      <div class="content">
        <el-form ref="form" class="form" :model="form" :rules="rules" label-width="70px" hide-required-asterisk>
          <el-form-item label="停诊日期" prop="date">
            <el-date-picker
              class="form_input"
              v-model="form.date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="停诊时段" prop="types">
            <el-select class="form_input" v-model="form.types" multiple placeholder="请选择">
              <el-option v-for="time in timeTypeList" :key="time.value" :label="time.label" :value="time.value"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: 'batchStop',
    data () {
      return {
        visible: false,
        timeTypeList: [
          { label: '上午', value: '1' },
          { label: '中午', value: '2' },
          { label: '下午', value: '3' },
          { label: '晚上', value: '4' }
        ],
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() < Date.now() - (24 * 60 * 60 * 1000) || time.getTime() > Date.now() + (59 * 24 * 60 * 60 * 1000);
          }
        },
        rules: {
          date: [
            { required: true, message: '请选择日期', trigger: 'change' }
          ]
        },
        form: {
          date: [],
          types: []
        }
      }
    },
    methods: {
      open () {
        this.visible = true
      },
      close () {
        this.visible = false
        this.form.date = []
        this.form.types = []
      },
      submit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            const info = {
              startTime: this.form.date[0],
              stopTime: this.form.date[1],
              timeTypes: this.form.types
            }
            this.$emit('submit', JSON.parse(JSON.stringify(info)))
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .batchStop /deep/ .el-dialog__header {
    padding: 12px 24px;
    border-bottom: 1px solid #E0E0E0 !important;
  }

  .batchStop /deep/ .el-dialog__title {
    font-weight: bold;
    font-size: 16px;
    color: #000000;
  }

  .batchStop /deep/ .el-dialog__headerbtn {
    top: 16px;
    right: 18px;
    height: 16px;
  }

  .batchStop /deep/ .el-dialog__body {
    padding: 0;
  }

  .batchStop /deep/ .el-dialog__footer {
    padding: 12px 16px;
    border-top: 1px solid #E0E0E0;
  }

  .content {
    padding: 20px 24px;
  }

  .form {
    overflow: hidden;
  }

  .form /deep/ .el-form-item__label {
    line-height: 32px;
    color: #667182;
  }

  .form /deep/ .el-form-item__content {
    line-height: 32px;
  }

  .form_input {
    width: 100%;
  }
</style>